import { render } from "./Spinner.vue?vue&type=template&id=04a18ff9"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=04a18ff9&lang=css"

import exportComponent from "C:\\wamp64\\www\\suph-annuaire-plugin\\suph-card-pro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__